// Create in Sketch

export default function CircleShapeIcon ({filled}) {

  return <>
    <svg width="24px" height="24px" viewBox="0 0 24 24">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity={filled ? 0.2 : 0}>
            <circle fill="#000000" stroke="#000000" strokeWidth="1.5" cx="12" cy="12" r="9"></circle>
        </g>
    </svg>
  </>
}
